import React from 'react';

interface Props {
   className?: string;
}

const Loading: React.FC<Props> = ({ className }: Props) => {
   return (
      <div className={`text-center ${className ?? ''}`}>
         <div className="lds-ring">
            <div/>
            <div/>
            <div/>
            <div/>
         </div>
      </div>
   );
};

export default Loading;
